"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagramComponent = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const react_1 = __importDefault(require("react"));
const react_svg_1 = require("react-svg");
const DiagramComponent = ({ width, height, onInteract, src, fileName, title, description, targetDetectionId, highlightIds, hideForegroundDrawing, zoomInScale, offsetX, offsetY, }) => {
    function adjustDiagramSize(svg) {
        var _a, _b, _c, _d, _e, _f;
        svg.setAttribute('width', width !== null && width !== void 0 ? width : `${(_c = (_b = (_a = svg.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width}`);
        svg.setAttribute('height', height !== null && height !== void 0 ? height : `${(_f = (_e = (_d = svg.parentElement) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.parentElement) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect().height}`);
    }
    function adjustForegroundGroups(svg) {
        if (hideForegroundDrawing) {
            const parentElement = svg.getElementById(fileName);
            const childrenElements = parentElement.children;
            for (let i = 0; i < childrenElements.length; i++) {
                const element = childrenElements[i];
                const elementId = element.id;
                if (elementId === 'bg') {
                    continue;
                }
                element.setAttribute('style', 'opacity:0.01');
            }
        }
    }
    function adjustZoomIn(svg) {
        var _a, _b, _c;
        const wholeBBox = svg.getBBox();
        const availableWidth = parseInt(width !== null && width !== void 0 ? width : `${(_c = (_b = (_a = svg.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width}`);
        const isMobile = availableWidth <= 500;
        if (zoomInScale <= 0 || zoomInScale === 1) {
            return;
        }
        const parentElement = svg.getElementById(fileName);
        const childrenElements = parentElement.children;
        for (let i = 0; i < childrenElements.length; i++) {
            const element = childrenElements[i];
            const elementId = element.id;
            if (elementId === 'bg') {
                continue;
            }
            if (elementId === targetDetectionId) {
                const elementBBox = convertCoordinates(element, svg);
                const centerX = elementBBox.x + elementBBox.width / 2 + offsetX;
                const centerY = elementBBox.y + elementBBox.height / 2 + offsetY;
                if (isMobile) {
                    if (Math.max(elementBBox.width, elementBBox.height) <= 50) {
                        zoomInScale = 3;
                    }
                    else if (Math.max(elementBBox.width, elementBBox.height) <= 100) {
                        zoomInScale = 2;
                    }
                }
                const scaleWidth = wholeBBox.width / zoomInScale;
                const scaleHeight = wholeBBox.height / zoomInScale;
                const newX = centerX - scaleWidth / 2;
                const newY = centerY - scaleHeight / 2;
                svg.setAttribute('viewBox', `${newX} ${newY} ${scaleWidth} ${scaleHeight}`);
            }
        }
        return;
    }
    function convertCoordinates(element, containerSVG) {
        const bbox = element.getBBox();
        const matrix = element.getCTM();
        let topLeft = containerSVG.createSVGPoint();
        let bottomRight = containerSVG.createSVGPoint();
        topLeft.x = bbox.x;
        topLeft.y = bbox.y;
        bottomRight.x = bbox.x + bbox.width;
        bottomRight.y = bbox.y + bbox.height;
        topLeft = topLeft.matrixTransform(matrix);
        bottomRight = bottomRight.matrixTransform(matrix);
        return {
            x: topLeft.x,
            y: topLeft.y,
            width: bottomRight.x - topLeft.x,
            height: bottomRight.y - topLeft.y,
        };
    }
    function handleHighlight(svg) {
        if (highlightIds.length === 0) {
            return;
        }
        const parentElement = svg.getElementById(fileName);
        const childrenElements = parentElement.children;
        for (let i = 0; i < childrenElements.length; i++) {
            const element = childrenElements[i];
            const elementId = element.id;
            if (elementId === 'bg') {
                continue;
            }
            if (highlightIds.includes(elementId)) {
                element.setAttribute('style', 'opacity:1');
                // element.classList.add('pulse');
                // svg.classList.add('pulse');
            }
            else {
                if (hideForegroundDrawing) {
                    element.setAttribute('style', 'opacity:0.01');
                }
                else {
                    element.setAttribute('style', 'opacity:0.3');
                }
            }
        }
    }
    function handleClick(e) {
        const clickedPointX = e.clientX;
        const clickedPointY = e.clientY;
        const parentElement = document.getElementById(fileName);
        if (!parentElement) {
            return;
        }
        const childrenElements = parentElement.children;
        const clickedElements = [];
        for (let i = 0; i < childrenElements.length; i++) {
            const element = childrenElements[i];
            const elementId = element.id;
            const rect = element.getBoundingClientRect();
            if (isPointInBounds(rect, clickedPointX, clickedPointY)) {
                if (elementId !== fileName) {
                    clickedElements.push(element);
                }
            }
        }
        if (clickedElements.length > 0) {
            const map = new Map();
            for (const element of clickedElements) {
                if (element.id === 'bg') {
                    continue;
                }
                let counter = 0;
                const rect = element.getBoundingClientRect();
                const points = generateDetectionPoints(clickedPointX, clickedPointY);
                for (const point of points) {
                    if (isPointInBounds(rect, point[0], point[1])) {
                        counter += 1;
                    }
                }
                map.set(element.id, counter);
            }
            let selectedId = undefined;
            const sum = Object.values(map).reduce((acc, value) => acc + value, 0);
            if (map.has(targetDetectionId) &&
                map.get(targetDetectionId) >= sum / 2) {
                selectedId = targetDetectionId;
            }
            else {
                let maxCounter = 0;
                map.forEach((counter, elementId) => {
                    if (counter > maxCounter) {
                        maxCounter = counter;
                        selectedId = elementId;
                    }
                });
            }
            if (!selectedId) {
                selectedId = 'bg';
            }
            if (selectedId && onInteract) {
                onInteract(selectedId);
            }
        }
    }
    function generateDetectionPoints(x, y) {
        function convertTupleToString(tuple) {
            return JSON.stringify(tuple);
        }
        function convertStringToTuple(str) {
            return JSON.parse(str);
        }
        const delta = 0.2;
        const radius = 3; // in pixel
        const count = radius / delta;
        const points = new Set();
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x + i * delta;
                const pointY = y + j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x - i * delta;
                const pointY = y - j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x + i * delta;
                const pointY = y - j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x - i * delta;
                const pointY = y + j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        return Array.from(points).map(str => convertStringToTuple(str));
    }
    function isPointInBounds(bound, x, y) {
        return (x >= bound.left && x <= bound.right && y >= bound.top && y <= bound.bottom);
    }
    function isPointInDrawing(element, x, y) {
        var _a;
        const pt = element.createSVGPoint();
        pt.x = x;
        pt.y = y;
        const svgPoint = pt.matrixTransform((_a = element.getScreenCTM()) === null || _a === void 0 ? void 0 : _a.inverse());
        const elementAtPoint = document.elementFromPoint(svgPoint.x, svgPoint.y);
        return element.contains(elementAtPoint);
    }
    return (react_1.default.createElement(react_svg_1.ReactSVG, { evalScripts: "always", afterInjection: svg => {
            adjustZoomIn(svg);
            adjustDiagramSize(svg);
            adjustForegroundGroups(svg);
            handleHighlight(svg);
        }, fallback: () => react_1.default.createElement("span", null, "Error!"), httpRequestWithCredentials: false, loading: () => react_1.default.createElement("span", null, "Loading"), onClick: e => {
            handleClick(e);
        }, onError: error => {
            console.error(error);
        }, src: src, title: title, desc: description, width: width, height: height }));
};
exports.DiagramComponent = DiagramComponent;
